import React, { useCallback, useRef, useState } from "react"
import styled, { useTheme } from "~/ui/styled"
import { globalToast } from "~utils"
import { handleScreenshot } from "~utils/screenshot"
import { Qrcode } from "~components/qrcode"
import { Avatar } from "~widgets/avatar"
import { Text, Button, CenterFlex, ColumnCenterFlex, BetweenFlex } from "~components/El"
import { usePopup } from "~hooks/usePopup"

const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  border-radius: 12px;
  overflow: hidden;
  box-sizing: border-box;
`

const ShotArea = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.blockBackground};
`

const QrcodeGroup: React.FC<any> = ({ current, canViewMemberIdentity }) => {
  const theme = useTheme()
  const popup = usePopup()
  if (!current) return null
  const { isDownload, isShare } = current
  const shotRef = useRef<HTMLDivElement>(null)
  const [loading, setLoading] = useState(false)

  const saveQrcode = useCallback(async () => {
    if (loading) return
    const node = shotRef.current
    if (!node) {
      globalToast.show("二维码组件未就绪")
      return
    }

    setLoading(true)
    try {
      await new Promise<void>((resolve) => requestAnimationFrame(() => resolve()))

      const qrImg = node.querySelector('img[alt="qrcode"]') as HTMLImageElement | null
      if (qrImg && !qrImg.complete) {
        await new Promise<void>((resolve) => {
          qrImg.onload = () => resolve()
          qrImg.onerror = () => resolve()
        })
      }

      const filename = `chat-qrcode-${Date.now()}`
      await handleScreenshot(node, filename, {
        quality: 1,
        backgroundColor: theme.colors.blockBackground,
        letterFallback: current?.title,
      })
      globalToast.show("保存成功")
    } catch (e) {
      globalToast.show(e?.message || "保存失败")
    } finally {
      setLoading(false)
    }
  }, [loading, theme.colors.blockBackground, current?.title])

  return (
    <Container>
      <ShotArea ref={shotRef}>
        <ColumnCenterFlex width="100%" bg={theme.colors.blockBackground}>
          <CenterFlex width="100%" height="50px" padding="0 15px">
            <Text color="text" fontWeight="600" fontSize={"18px"}>
              {current.chatTypeEnum === "GROUP" ? "群聊" : "频道"}二维码
            </Text>
          </CenterFlex>
          <Avatar size={60} avatar={current?.image} name={current?.title} />
          <Text color={"text"} fontSize={"16px"} fontWeight="600" mt="5px">
            {current?.title}
          </Text>
          <Text color={"secondaryText"} fontSize={"12px"}>
            ID：{canViewMemberIdentity ? current?.name || "" : "***"}
          </Text>
          <Qrcode
            value={current?.groupQrcode}
            avatar={current?.image}
            name={current?.title}
            size={180}
            description={`扫一扫上面的二维码，申请加入${current.chatTypeEnum === "GROUP" ? "群聊" : "频道"}`}
            isDownload={isDownload}
            isShare={isShare}
          />
        </ColumnCenterFlex>
      </ShotArea>
      <BetweenFlex gap="10px" width="100%" padding="15px" className="no-screenshot">
        <Button
          flex={1}
          bg="background"
          borderRadius="10px"
          height="40px"
          onClick={() => {
            popup?.close()
          }}
        >
          <Text color="secondaryText">关闭</Text>
        </Button>
        <Button
          flex={1}
          bg="buttonBackground"
          borderRadius="10px"
          height="40px"
          disabled={loading}
          onClick={saveQrcode}
        >
          <Text color="#fff" fontWeight="600">
            {loading ? "保存中..." : "保存二维码"}
          </Text>
        </Button>
      </BetweenFlex>
    </Container>
  )
}

export default QrcodeGroup
